/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum CreateBiddersForAuctionConflictType {
  AuctionNotFound = 'auction_not_found',
  UserNotFound = 'user_not_found',
  BiddersAlreadyExistForAuction = 'bidders_already_exist_for_auction'
}
